module.exports = __webpack_public_path__ + "img/calendar-chevron-right.3f9f8169.svg";